import { USER_TYPES } from '../enums';

class PermissionsService {
  constructor() {
    this.cachedHasAccess = null;
    this.lastCheckedUserId = null;
  }

  hasAccess(user) {
    if (this.cachedHasAccess !== null && user?.id === this.lastCheckedUserId) {
      return this.cachedHasAccess;
    }

    const hasAccess = this.evaluateUserAccess(user);

    this.cachedHasAccess = hasAccess;
    this.lastCheckedUserId = user?.id || null;

    return hasAccess;
  }

  evaluateUserAccess(user) {
    if (!user) {
      return false;
    }

    if (this.isDriverUser(user)) {
      return false;
    }

    return true;
  }

  isDriverUser(user) {
    return user.userType === USER_TYPES.DRIVER || user.userType === USER_TYPES.EMT_E;
  }

  clearCache() {
    this.cachedHasAccess = null;
    this.lastCheckedUserId = null;
  }
}

export const createPermissionsService = () => new PermissionsService();
export default createPermissionsService();
